export enum FocalTypeEnum {
  EQUIVALENT = 'equivalent',
  EFFECTIVE = 'effective'
}
